import { Icon } from '@nazka/nazka.mapframe.components';
import { Pie, PieChart } from 'recharts';

import PopupTitle from '@App/components/MaplibreMap/PopupTitle';
import { useTranslation } from '@utils/i18n/i18n';

import { getChartData } from './species-popup.utils';

import './species-popup.css';

function SpeciesPopup({ feature }) {
  const chartData = getChartData(feature);
  const total = chartData.reduce((sum, d) => sum + d.value, 0);

  const { t } = useTranslation();

  return (
    <div className="species-popup">
      <PopupTitle>{feature?.properties?.name}</PopupTitle>
      <div className="species-popup__content">
        <div className="species-popup__chart">
          {chartData.length > 0 && (
            <PieChart width={160} height={160}>
              <Pie
                isAnimationActive={true}
                data={chartData}
                dataKey="value"
                nameKey="label"
                cx="50%"
                cy="50%"
                innerRadius="80%"
                outerRadius="100%"
                cornerRadius="50%"
                paddingAngle={5}
                stroke="none"
              />
            </PieChart>
          )}
        </div>
        <div className="species-popup__legend">
          {chartData.length > 0
            ? chartData.map(({ key, label, color, icon, value }) => (
                <div key={key} className="species-popup__legend-item">
                  <Icon
                    className="species-popup__legend-icon"
                    css={{ backgroundColor: color }}
                    color="white"
                    icon={icon}
                    size="36px"
                  />
                  <div className="species-popup__legend-text">
                    <span>{label}</span>
                    <span>
                      <strong>
                        {(value / total * 100).toFixed(2)}
                        %
                      </strong>
                      <span>
                        {` (${value})`}
                      </span>
                    </span>
                  </div>
                </div>
              ))
            : (
                <p className="species-popup__empty">{t('No species group data available.')}</p>
              )}
        </div>
      </div>
    </div>
  );
}

export default SpeciesPopup;
